export default {
    changePrice (ctx, price) {
        ctx.commit ('changePrice', price)
    },
    changeIsAuth (ctx,user_id) {
        ctx.commit ('changeIsAuth',user_id)
    },
}
